import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Box, Button, Pagination } from "@mui/material";

interface PaginationControlProps {
  page: number;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  totalRows?: number;
}

const MAX_ITEMS_PER_PAGE: number = 10;

const PaginationControl = ({
  page,
  onPageChange,
  totalRows = 0,
}: PaginationControlProps) => {
  if (totalRows === 0) return null;

  const totalPages = Math.ceil(totalRows / MAX_ITEMS_PER_PAGE);
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
      <Button
        variant="outlined"
        startIcon={
          <ArrowBack
            sx={{
              color: "#414651",
              fontSize: "20px",
              mr: 1,
            }}
          />
        }
        sx={{
          border: "1px solid #D5D7DA",
          borderRadius: "8px",
          height: "40px",
          padding: "8px 16px",
          textTransform: "none",
          color: "#717680",
          bgcolor: "white",
          "&:hover": {
            bgcolor: "#f5f5f5",
            border: "1px solid #D5D7DA",
          },
        }}
        disabled={page <= 1}
        onClick={(event) => onPageChange(event, page - 1)}
      >
        <Box
          sx={{
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: 1.2,
          }}
        >
          Previous
        </Box>
      </Button>
      <Pagination
        shape="rounded"
        count={totalPages}
        hideNextButton
        hidePrevButton
        page={page}
        onChange={(_, page) => onPageChange(_, page)}
        sx={{
          "& .MuiPaginationItem-root": {
            fontWeight: 600,
            fontSize: "14px",
          },
          color: "rgba(250, 250, 250, 1)",
        }}
      />
      <Button
        variant="outlined"
        endIcon={
          <ArrowForward
            sx={{
              color: "#414651",
              fontSize: "20px",
              mr: 1,
            }}
          />
        }
        sx={{
          border: "1px solid #D5D7DA",
          borderRadius: "8px",
          height: "40px",
          padding: "8px 16px",
          textTransform: "none",
          color: "#717680",
          bgcolor: "white",
          "&:hover": {
            bgcolor: "#f5f5f5",
            border: "1px solid #D5D7DA",
          },
        }}
        disabled={page >= totalPages}
        onClick={(event) => onPageChange(event, page + 1)}
      >
        <Box
          sx={{
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: 1.2,
          }}
        >
          Next
        </Box>
      </Button>
    </Box>
  );
};

export default PaginationControl;
